<script>
import config from '@/config'
import { getSubMenuCache } from '@/views/global/functions'
const basePath = config.ApiYJ

function elementFixDetail (target, fixElement, refline, isMaxHeight, callBack) {
  target.$nextTick(() => {
    let height =
      refline.getBoundingClientRect().y - fixElement.getBoundingClientRect().y
    if (callBack) {
      callBack(height)
    }
    if (isMaxHeight) {
      fixElement.style.maxHeight = `${height}px`
    } else {
      fixElement.style.height = `${height}px`
    }
  })
}

// 表单验证
// 验证是否是手机号码
const checkIsCellphoneNumber = (rule, value, callback) => {
  if (!value) {
    callback(new Error('请输入手机号码'))
  } else {
    const reg = /^1[3|4|5|7|8|9][0-9]\d{8}$/
    if (reg.test(value)) {
      callback()
    } else {
      return callback(new Error('请输入正确的手机号码'))
    }
  }
}
// 中名验证
const chnName = (rule, value, callback) => {
  if (!value) {
    callback(new Error('请输入中文名'))
  } else {
    const reg = /^[\u4e00-\u9fa5]+$/
    if (value.length < 100 && reg.test(value)) {
      callback()
    } else {
      return callback(new Error('请输入正确的中文名'))
    }
  }
}
// 经度
const checkLong = (rule, value, callback) => {
  if (!value) {
    // callback(new Error('请输入经度'))
  } else {
    const reg = /^-?(([1-9]\d?)|(1[1-7]\d)|180)(\.\d{1,6})?$/
    if (reg.test(value)) {
      callback()
    } else {
      return callback(new Error('请输入正确的经度'))
    }
  }
}
// 纬度
const checkLat = (rule, value, callback) => {
  if (!value) {
    // callback(new Error('请输入纬度'))
  } else {
    const reg = /^-?(([1-8]\d?)|([1-8]\d)|90)(\.\d{1,6})?$/
    if (reg.test(value)) {
      callback()
    } else {
      return callback(new Error('请输入正确的纬度'))
    }
  }
}
// 数字
const checkNumeral = (rule, value, callback) => {
  if (value !== undefined && value !== '') {
    setTimeout(() => {
      var regPos = /^\d+(\.\d+)?$/
      var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/
      if (regPos.test(value) || regNeg.test(value)) {
        callback()
      } else {
        callback(new Error('请输入数字'))
      }
    }, 1000)
  } else {
    callback()
  }
}
// 密码
const checkPassword = (rule, value, callback) => {
  if (!value) {
    callback(new Error('密码不能为空'))
  } else {
    var reg = new RegExp('(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])')
    if (!reg.test(value)) {
      return callback(new Error('密码须包含数字和大小写字母及特殊字符'))
    } else {
      callback()
    }
  }
}
// 表单验证

// 时间格式化 2014-10-16 11:03
const timeFormat = function (time) {
  var year = time.getFullYear() // 年
  var month = time.getMonth() + 1 // 月
  var day = time.getDate() // 日
  var hh = time.getHours() // 时
  var mm = time.getMinutes() // 分
  var clock = year + '-'
  if (month < 10) { clock += '0' }
  clock += month + '-'
  if (day < 10) { clock += '0' }
  clock += day + ' '
  if (hh < 10) { clock += '0' }
  clock += hh + ':'
  if (mm < 10) clock += '0'
  clock += mm
  return (clock)
}

// 清除表单验证
const clearValidate = function (target, name) {
  target.$nextTick(() => {
    target.$refs[name].clearValidate()
  })
}

// 查询组件清空时查询
const emptyQuery = function (value, callback) {
  if (value === '' || value === null || value === undefined) {
    callback()
  }
}

const elementFix = function (target, fixElement, refline, isMaxHeight, callBack) {
  elementFixDetail(target, fixElement, refline, isMaxHeight, callBack)
  window.addEventListener('resize', () => {
    elementFixDetail(target, fixElement, refline, isMaxHeight, callBack)
  })
}

// const pickerOptionsStart = function (val) {
//   return {
//     disabledDate (time) {
//       if (val) {
//         return time.getTime() > new Date(val).getTime()
//       }
//     }
//   }
// }

// const pickerOptionsEnd = function (val) {
//   return {
//     disabledDate (time) {
//       if (val) {
//         return new Date(time.setDate(time.getDate() + 1)).getTime() < new Date(val).getTime()
//       }
//     }
//   }
// }
// 时间控件限制，开始结束时间限制
const pickerOptionsStart = function (val) {
  return {
    disabledDate (time) {
      if (val) {
        return time.getTime() > new Date(val).getTime()
      } else {
        return time.getTime() > Date.now()
      }
    }
  }
}
const pickerOptionsEnd = function (val) {
  return {
    disabledDate (time) {
      if (val) {
        return time.getTime() < new Date(val).getTime() - 8.64e7 || time.getTime() > Date.now()
      } else {
        return time.getTime() > Date.now()
      }
    }
  }
}
// 查询组件清空时包含对象查询
const emptyQueryObj = function (value, callback) {
  if (value === '' || value === null || value === undefined || value === {} || value.length === 0) {
    callback()
  }
}
// 获取iframeUrl
const getIframeUrl = function (target) {
  let menu = getSubMenuCache() || JSON.parse(localStorage.subMenu || 'null')
  if (!menu) return ''
  let meunLi = menu.find(el => { return el.menuInfo.name === target.$route.meta })
  if (!meunLi) return ''
  let obj = meunLi.chidMenuInfo.find(el => { return el.menuInfo.url === target.$route.name })
  return obj ? obj.menuInfo.iframeUrl : ''
}
// 地图marker去重合并
const filterArr = function (arr, ...arg) {
  for (let argarr of arg) {
    if (Array.isArray(argarr) && Array.isArray(arr)) {
      for (let i = 0; i < argarr.length; i++) {
        const el = argarr[i]
        let obj = arr.find(item => { return item.options.name === el.options.name })
        if (!obj && el.options.tooltipShow) {
          arr.push(el)
        }
      }
    }
  }
}
// 计算两个时间差
const differenceTime = function (beginTime, endTime) {
  let dateBegin = new Date(beginTime)
  let dateEnd = new Date(endTime)
  let dateDiff = dateEnd.getTime() - dateBegin.getTime() // 时间差的毫秒数
  let dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000)) // 计算出相差天数
  return dayDiff
}
export default
{
  basePath,
  checkIsCellphoneNumber,
  chnName,
  checkLat,
  checkLong,
  checkNumeral,
  timeFormat,
  clearValidate,
  emptyQuery,
  emptyQueryObj,
  elementFix,
  checkPassword,
  pickerOptionsStart,
  pickerOptionsEnd,
  getIframeUrl,
  filterArr,
  differenceTime
}
</script>
